/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mock_Sermon_AlertInputs */

const en_mock_sermon_alert = /** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The session materials for this week are now live in the vault. 🕊️`)
};

const es_mock_sermon_alert = /** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los materiales de la sesión de esta semana ya están disponibles en la bóveda. 🕊️`)
};

const fr_mock_sermon_alert = /** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le matériel de session pour cette semaine est maintenant en ligne dans le coffre-fort. 🕊️`)
};

const de_mock_sermon_alert = /** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sitzungsmaterialien für diese Woche sind jetzt im Vault live. 🕊️`)
};

const id_mock_sermon_alert = /** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materi sesi untuk minggu ini sekarang tayang di Vault. 🕊️`)
};

/** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */
const ja_mock_sermon_alert = en_mock_sermon_alert;

/** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */
const zh_mock_sermon_alert = en_mock_sermon_alert;

/** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */
const ar_mock_sermon_alert = en_mock_sermon_alert;

/** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */
const it_mock_sermon_alert = en_mock_sermon_alert;

/** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */
const ru_mock_sermon_alert = en_mock_sermon_alert;

/** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */
const pt_mock_sermon_alert = en_mock_sermon_alert;

/** @type {(inputs: Mock_Sermon_AlertInputs) => LocalizedString} */
const ko_mock_sermon_alert = en_mock_sermon_alert;

/**
* | output |
* | --- |
* | "The session materials for this week are now live in the vault. 🕊️" |
*
* @param {Mock_Sermon_AlertInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mock_sermon_alert = /** @type {((inputs?: Mock_Sermon_AlertInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mock_Sermon_AlertInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mock_sermon_alert(inputs)
	if (locale === "es") return es_mock_sermon_alert(inputs)
	if (locale === "fr") return fr_mock_sermon_alert(inputs)
	if (locale === "de") return de_mock_sermon_alert(inputs)
	if (locale === "ja") return ja_mock_sermon_alert(inputs)
	if (locale === "zh") return zh_mock_sermon_alert(inputs)
	if (locale === "ar") return ar_mock_sermon_alert(inputs)
	if (locale === "id") return id_mock_sermon_alert(inputs)
	if (locale === "it") return it_mock_sermon_alert(inputs)
	if (locale === "ru") return ru_mock_sermon_alert(inputs)
	if (locale === "pt") return pt_mock_sermon_alert(inputs)
	return ko_mock_sermon_alert(inputs)
});